import { ButtonIcon, ButtonLink, IconBookmark } from 'braid-design-system';
import { useTranslations } from '@vocab/react';

import translations from './.vocab';
import type { SaveJobProps } from '../../SaveJob.tsx';

const SaveJobForSignedOut = ({
  isSplitView,
  jobId,
  returnUrl,
  toggleSavedJob,
}: Omit<SaveJobProps, 'isAuthenticated' | 'isApplied' | 'isSaved'>) => {
  const { t } = useTranslations(translations);

  return isSplitView ? (
    <ButtonIcon
      id={`serp-signed-out-save-job-${jobId}`}
      label={t('Sign in to save this job')}
      variant="transparent"
      data={{ automation: 'signed-out-save-job' }}
      icon={<IconBookmark />}
      onClick={toggleSavedJob}
    />
  ) : (
    <ButtonLink
      href={returnUrl}
      rel="nofollow"
      aria-label={t('Sign in to save this job')}
      data={{ automation: 'signed-out-save-job' }}
      tone="neutral"
      variant="transparent"
      bleed
      icon={<IconBookmark />}
      onClick={toggleSavedJob}
    >
      {t('Save')}
    </ButtonLink>
  );
};

export default SaveJobForSignedOut;
